"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _KingBird = _interopRequireDefault(require("../../KingBird"));

var _Netvigator = _interopRequireDefault(require("../../Netvigator"));

var _NetvigatorItem = require("../../NetvigatorItem");

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

// todo 样式文件直接引用 selfNavigation
function SelfNavigation(props) {
  var _a = props || {},
      configuration = _a.configuration,
      _b = _a.colorTheme,
      colorTheme = _b === void 0 ? '' : _b;

  var _c = (0, _react.useState)(false),
      expendNode = _c[0],
      setExpendNode = _c[1];

  var _d = (0, _react.useState)(configuration ? configuration[0] : {}),
      currentTxt = _d[0],
      setCurrentTxt = _d[1];

  var containerRef = (0, _react.useRef)(null);
  var liElement = (0, _react.useRef)(null);

  var _e = (0, _react.useState)(false),
      isFix = _e[0],
      setIsFix = _e[1];

  (0, _react.useEffect)(function () {
    if (!containerRef.current) return;
    var winWidth = document.documentElement.offsetWidth || document.body.offsetWidth;

    if (winWidth <= 768) {
      containerRef.current.style.display = 'block';
    } else {
      containerRef.current.style.display = 'none';
    }

    var fixFunc = (0, _utils.throttle)(function () {
      if ((0, _utils.getWinScrollY)() >= 44) {
        isFix !== true && setIsFix(true);
      } else {
        isFix !== false && setIsFix(false);
      }
    }, 50);
    fixFunc();
    window.addEventListener('scroll', fixFunc);
    return function () {
      window.removeEventListener('scroll', fixFunc);
    };
  }, [isFix]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: isFix ? {
      top: '0'
    } : {
      top: '56px'
    },
    ref: containerRef,
    className: 'self-navigation-container'
  }, /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick() {
      if (!liElement.current || !liElement.current.style) return;
      var tempHeight = 0;

      if (!expendNode) {
        setExpendNode(true);
        tempHeight = configuration.length ? configuration.length * 56 + "px" : 0;
      } else {
        setExpendNode(false);
        tempHeight = '0';
      }

      if (typeof tempHeight === 'string') {
        liElement.current.style.height = tempHeight;
      }
    },
    className: 'self-navigation-container__nav'
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: 'self-navigation-container__nav__h3'
  }, currentTxt ? currentTxt.label : ''), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('self-navigation-container__nav__span', {
      'self-navigation-container__nav__span--rotate': expendNode
    })
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "design-iconfont"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#FFF",
    transform: "rotate(-180 12.25 12.25)",
    d: "M12.5 10.8035221L17.6191093 16 19 14.5982389 12.5 8 6 14.5982389 7.3808907 16z",
    fillRule: "evenodd"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    ref: liElement,
    style: {
      height: '0',
      overflow: 'hidden',
      transition: ' all 0.3s ease-in-out'
    },
    className: (0, _classnames["default"])('self-navigation-container__node')
  }, configuration.map(function (item, index) {
    var _a = item || {},
        anchorId = _a.anchorId,
        label = _a.label;

    return /*#__PURE__*/_react["default"].createElement("a", {
      onClick: function onClick() {
        // @ts-ignore
        liElement.current.style.height = 0;
        setCurrentTxt(__assign(__assign({}, currentTxt || {}), {
          label: label
        }));
        setExpendNode(!expendNode);
      },
      key: index,
      className: (0, _classnames["default"])('self-navigation-container__nav self-navigation-container__nav--hover', {
        studentcolor: colorTheme === 'studentactivities'
      }),
      href: anchorId
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      style: (currentTxt || {}).label === label ? colorTheme === 'studentactivities' ? {
        color: '#15B260'
      } : {
        color: '#006eff'
      } : {},
      className: 'self-navigation-container__nav__h3 self-navigation-container__nav__h3--extend'
    }, label));
  })));
}

var FlexNavigate = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
      banner = props.banner,
      sharp = props.sharp,
      radius = props.radius,
      style = props.style,
      _a = props.configuration,
      configuration = _a === void 0 ? [] : _a,
      onClick = props.onClick,
      onTabClick = props.onTabClick,
      _b = props.colorTheme,
      colorTheme = _b === void 0 ? '' : _b,
      _c = props.isExternal,
      isExternal = _c === void 0 ? false : _c,
      // 新增外配属性，是否是低代码自定义配置的
  _d = props.btnLink,
      // 新增外配属性，是否是低代码自定义配置的
  btnLink = _d === void 0 ? {} : _d,
      onCallBack = props.onCallBack,
      restProps = __rest(props, ["icon", "banner", "sharp", "radius", "style", "configuration", "onClick", "onTabClick", "colorTheme", "isExternal", "btnLink", "onCallBack"]);

  var mobileConfiguration = configuration ? configuration.map(function (item, index) {
    return {
      key: index + 1,
      anchorId: item.anchorId ? "#" + item.anchorId : "#" + item.label,
      label: item.label
    };
  }) : [];
  var isExternalResult = configuration && configuration.length >= 4;

  if (isExternal) {
    isExternalResult = true;
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isExternalResult ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_KingBird["default"], __assign({
    style: style || {},
    ref: ref
  }, restProps, {
    btnLink: btnLink,
    onCallBack: onCallBack
  }), /*#__PURE__*/_react["default"].createElement(_Netvigator["default"], {
    theme: "black",
    size: "small",
    display: "bottom",
    selected: "0",
    divider: true,
    colorTheme: colorTheme
  }, configuration.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_NetvigatorItem.NetvigatorItem, {
      key: index,
      link: item.anchorId || item.link || item.label,
      onTabClick: onTabClick,
      index: index,
      record: item
    }, item.label);
  }))), /*#__PURE__*/_react["default"].createElement(SelfNavigation, {
    top: 100,
    configuration: mobileConfiguration,
    colorTheme: colorTheme
  })) : null);
});
FlexNavigate.displayName = 'TCIFlexNavigate';
var _default = FlexNavigate;
exports["default"] = _default;